import { GeneralService } from './general.service';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from './notification.service';
import { ColumnsListDTO } from '../entity/dto/columnslist.component';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})

export class ResumeAllFormsService extends BaseService<any> {
    listColumn: ColumnsListDTO[] = [];
    valoresAlterados: any = [];
    listColumnSec002: any = [
        {
            alias: "Cerar",
            name: "cd_cerar"
        },
        {
            alias: "Contrato",
            name: "cd_contrato"
        },
        {
            alias: "Peso Rw (kg)",
            name: "qt_rw_kg"
        },
        {
            alias: "% Umidade Direcionamento",
            name: "qt_porcentagem_umidade_direcionamento"
        },
        {
            alias: "% Umidade CERAR",
            name: "qt_umidade_cerar"
        },
        {
            alias: "% Descarregado",
            name: "qt_porcentagem_descarregado"
        },
        {
            alias: "Temperatura Máxima Transporte (ºC)",
            name: "qt_temperatura_maxima_do_tempo_total_de_transporte"
        },


    ];


    // qt_umidade_cerar: [null],
    // qt_porcentagem_descarregado: [null],
    // qt_temperatura_maxima_do_tempo_total_de_transporte: [null],
    // cd_lote_rw: [null],
    constructor(http: HttpClient, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super(http);
    }

    compareAdd = async (valuesPrev, valuesCurrent, isAdd, sheet) => {

        this.valoresAlterados = [];

        let promise = await new Promise<ColumnsListDTO[]>((resolve, reject) => {
            this.getListColumnSheet(sheet).then(res => {
                this.listColumn = res;
                resolve(res)
            })
        })

        Object.keys(valuesCurrent).forEach(function (val, idx, array) {
            if (valuesCurrent[val] instanceof Date) {
                valuesCurrent[val] = moment(valuesCurrent[val]).format("YYYY-MM-DDTHH:mm:SS")
            }
            if (typeof valuesCurrent[val] == "undefined") {
                valuesCurrent[val] = null;
            }
            if (valuesCurrent[val] == "") {
                valuesCurrent[val] = null;
            }
        })
        Object.keys(valuesPrev).forEach(function (val, idx, array) {

            if ((val == 'list_loteds' && valuesPrev[val] == '') || (val == 'list_sdc' && valuesPrev[val] == '')) {
                valuesPrev[val] = null;

            }

            if ((val == 'list_loteds' && valuesPrev[val] == '') || (val == 'list_sdc' && valuesPrev[val] == '')) {
                valuesPrev[val] = null;

            }

            if (typeof valuesPrev[val] == 'number' && valuesPrev[val] == 0 && (valuesCurrent[val] == null || valuesCurrent[val] == '')) {

                valuesCurrent[val] = 0;

            }
            if (typeof valuesPrev[val] == 'number' && typeof valuesCurrent[val] == 'string') {

                valuesCurrent[val] = Number(valuesCurrent[val]);
            }

            if (parseInt(valuesPrev[val]) == parseFloat(valuesPrev[val]) && !isNaN(valuesPrev[val]) && parseInt(valuesCurrent[val]) != parseFloat(valuesCurrent[val]) && !isNaN(valuesCurrent[val]) && val == 'total_sacos') {

                valuesCurrent[val] = Math.ceil(valuesCurrent[val])

            }
            if (valuesCurrent[val] != null && parseInt(valuesCurrent[val]) != parseFloat(valuesCurrent[val]) && !isNaN(valuesCurrent[val])) {


                valuesCurrent[val] = Number(Number(valuesCurrent[val]).toFixed(2));
                valuesPrev[val] = Number(Number(valuesPrev[val]).toFixed(2));



            }
        });

        if (sheet == 'sec002_agg') {
            this.listColumnSec002.forEach(element => {
                promise.push(element)
            });
        }

        promise.forEach(value => {
            var listLoteForm = valuesCurrent['list_loteds']?.filter(item => item.hasOwnProperty(value.name));
            var listSdcForm = valuesCurrent['list_sdc']?.filter(item => item.hasOwnProperty(value.name));
            var listLoteBD = valuesPrev['list_loteds']?.filter(item => item.hasOwnProperty(value.name));
            var listSdcBD = valuesPrev['list_sdc']?.filter(item => item.hasOwnProperty(value.name));
            var countLoteForm = listLoteForm?.length > 0 ? true : false;
            var countSdcForm = listSdcForm?.length > 0 ? true : false;
            var countLoteBD = listLoteBD?.length > 0 ? true : false;
            var countSdcBD = listSdcBD?.length > 0 ? true : false;
            if (isAdd && valuesCurrent[value.name]) {
                this.valoresAlterados.push({
                    title: value.alias,
                    valuePrev: valuesCurrent[value.name],
                    valueC: valuesCurrent[value.name]
                });
            } else if (!isAdd && valuesCurrent[value.name] !== valuesPrev[value.name] && valuesCurrent[value.name] != undefined) {
                this.valoresAlterados.push({
                    title: value.alias,
                    valuePrev: valuesPrev[value.name],
                    valueC: valuesCurrent[value.name]
                });
            }
            else if (!isAdd && value.name != 'list_loteds' && value.name != 'id' && sheet == 'sec002_agg' && (countLoteForm || countSdcForm || countLoteBD || countSdcBD)) {
                var listA = countLoteForm ? listLoteForm : countSdcForm ? listSdcForm : [];
                var listB = countLoteBD ? listLoteBD : countSdcBD ? listSdcBD : [];

                if (!isAdd && !this.equalsCheck(listA, listB)) {

                    this.validatorsArr(listA, listB, value);
                }

            } else if (isAdd && value.name != 'list_loteds' && value.name != 'id' && sheet == 'sec002_agg' && (countLoteForm || countSdcForm || countLoteBD || countSdcBD)) {

                let listA = countLoteForm ? listLoteForm : countSdcForm ? listSdcForm : [];
                let listB = [];
                this.validatorsArr(listA, listB, value);
            }
        });


    }


    validatorsArr(listA, listB, value) {

        if (listA.length > listB.length) {
            const { newListA, newListB } = this.equalizedArray(listA, listB)
            listA = newListA;
            listB = newListB;
        }
        if (listB.length > listA.length) {
            const { newListA, newListB } = this.equalizedArray(listB, listA)
            listA = newListB;
            listB = newListA;
        }
        // const arrIndex = this.equalsCheckIndex(listA, listB)
        var arrObj = this.equalsCheckObj(listA, listB)
        arrObj.forEach((item) => {

            if (item.key == value.name) {
                this.valoresAlterados.push({
                    title: value.alias,
                    valuePrev: listB[item.index][item.key],
                    valueC: listA[item.index][item.key]
                });
            }
        })
    }

    equalsCheckObj = (a, b): Array<any> => {
        const keysA = Object.keys(a);
        var arrKey = []
        for (let index = 0; index < keysA.length; index++) {
            const keys = Object.keys(a[keysA[index]]);
            keys.forEach(k => {
                if (!this.equalsCheck(a[index][k], b[index][k])) {
                    arrKey.push({ index, key: k })
                }

            })

        }
        return arrKey

    }
    equalsCheck = (a, b) => {
        // If they point to the same instance of the array
        if (a === b)
            return true;

        // If they point to the same instance of date
        if (a instanceof Date && b instanceof Date)
            return a.getTime() === b.getTime();

        // If both of them are not null and their type is not an object
        if (!a || !b || (typeof a !== 'object' && typeof b !== 'object'))
            return a === b;

        // This means the elements are objects
        // If they are not the same type of objects
        if (a.prototype !== b.prototype)
            return false;

        // Check if both of the objects have the same number of keys
        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length)
            return false;

        // Check recursively for every key in both
        return keys.every(k => this.equalsCheck(a[k], b[k]));
    };

    equalizedArray(listA: Array<any>, listB: Array<any>): { newListA: any; newListB: any; } {
        const ArrObjA = Object.keys(listA[0])
        const objA = ArrObjA.reduce((a, v) => ({ ...a, [v]: null }), {})
        const countList = (listA.length - listB.length);
        for (let index = 0; index < countList; index++) {
            listB.push(objA);

        }
        return { newListA: listA, newListB: listB };
    }
}
